import { customToast } from "../../../../../App";
import { store } from "../../../../../store";
import { showToast } from "../../store/model/model.action";
import { FILE_MANAGEMENT_CONSTANTS } from "./constant";

export const dateFormat = (dateString: any) => {
  try {
    const options: any = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };
    const formatted = new Date(dateString).toLocaleDateString("en-US", options);
    const dateParts = formatted
      .substring(0, formatted.indexOf(","))
      .split(" ")
      .reverse()
      .join(" ");
    // Return the formatted date with uppercase month abbreviation and desired format
    const formattedDate =
      dateParts + formatted.substr(formatted.indexOf(",") + 1);
    return formattedDate;
  } catch (error) {
    return dateString;
  }
};

export const queryStringToObject = (queryString: any) => {
  const queryStringObj = new URLSearchParams(queryString).toString();
  return queryStringObj;
};

export function addUniqueName(arr: any[], newName: string) {
  const existingNames = arr.map((item: any) => {
    let folderName = "";
    if (item?.fileName != "") {
      folderName = item?.fileName?.toString() || "";
    } else {
      folderName = item?.path
        ? item.path.split("/").filter(Boolean)[0]?.toString()
        : "";
    }
    return folderName;
  });
  let uniqueName = newName;
  let counter = 1;
  while (existingNames.includes(uniqueName)) {
    uniqueName = `${newName}_${counter}`;
    counter++;
  }

  return uniqueName;
}

export const dateFormatFun = (utcDate: any) => {
  const options: any = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };
  const formatted = new Date(utcDate).toLocaleDateString("en-US", options);
  const dateParts = formatted
    .substring(0, formatted.indexOf(","))
    .split(" ")
    .reverse()
    .join(" ");
  // Return the formatted date with uppercase month abbreviation and desired format
  const formattedDate =
    dateParts + formatted.substr(formatted.indexOf(",") + 1);
  return formattedDate;
};


export const convertDataGB = (val: any, type: any) => {
  let gbVal;
  if (type?.toLowerCase() === "kb") {
    gbVal = val / 1024 / 1024;
  }
  if (type?.toLowerCase() === "mb") {
    gbVal = val / 1024;
  }
  return gbVal;
};
export const splitFun = (input: any) => {
  const splitArray = input.match(/([\d\.]+)(.*)/);
  return {
    numeric: splitArray?.[1],
    nonnumeric: splitArray?.[2],
  };
};

export const blobFlow = async (blobSize: any) => {
  if (blobSize === "0Bytes") {
    return 0
  } else if (blobSize) {
    let consize = splitFun(blobSize);
    if (consize.nonnumeric.toLowerCase() !== "gb") {
      let resConsume = convertDataGB(consize.numeric, consize.nonnumeric);
      if (resConsume) {
        // let roundNum = Math.round(resConsume);
        return resConsume
      }
    } else {
      if (consize.numeric) {
        return consize.numeric
      }
    }
  }
};

export const rendererFileSizeCol = (fileSize: any) => {
  if (!fileSize) return '';
  else {
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(fileSize) / Math.log(k));
    let value: any = (fileSize / Math.pow(k, i)).toFixed(4);
    if (value % 1 === 0) {
      value = fileSize / Math.pow(k, i);
    } else {
      value = (fileSize / Math.pow(k, i)).toFixed(2);
    }
    return `${value} ${sizes[i]}`
  }
};

export const verifyFile = (file: any,fileUploader: any) => {
  const Centralstore = store.dispatch
  const maxFileSize = 2147483648;
  if (file.size > maxFileSize) {
    fileUploader.current.value = "";
    Centralstore(showToast({
      content: FILE_MANAGEMENT_CONSTANTS.FILE_SIZE_EXCEEDS_LIMIT,
      type: "warning"
    }));
    return false;
  }
  else if(file.name?.length>100){
    fileUploader.current.value = "";
    Centralstore(showToast({
      content: FILE_MANAGEMENT_CONSTANTS.FILE_NAME_EXCEEDS_LIMIT,
      type: "warning"
    }));
    return false;
  }

  return true;
};

